import React, { Component } from "react";
import Table from '../../components/Table/MessageTable';
import {Button,FormControl,Row,Col,Modal,FormGroup,MenuItem,DropdownButton,ControlLabel } from "react-bootstrap";
import { addMessage, getMessages, deleteMessage, editMessage } from "../../services/GameServices";


class Message extends Component{

    constructor(props){
        super(props);
        
        this.state ={
            messages:[],
            modalActive:false,
            editObj: {cat: "", txt: "",head:""},
        };
    }
    componentDidMount(){
        //load data saved as text and place it instead of 
        //class type
        //get all messages api 
        //setState
        
        let myoobj={cat: "", txt: "",head:""};  
        getMessages().then((response) => {
            let rd= response.data;
              console.log('response is cool ',rd);
              console.log("State obj",rd.messages);
              this.setState({messages:rd.messages});
              this.setState({editObj:myoobj})
        })
        .catch((err) => {
            console.log("Catch an eror in geting messages",err)
          });
    }
    handleEditChange = (e, attribute) => {
        const target = e.target;
        let temp = Object.assign({}, this.state.editObj);
        temp[attribute] = target.value;
        this.setState({ editObj: temp });
      }
      
      handleSelect = (e) =>{
        console.log("handle select",e);
        console.log(typeof(e));
        let n= Number(e);
        console.log(n);
        let cur='';
        switch(n){
            case 1: cur='Winter';  break;
            case 2: cur='Spring';  break;
            case 3: cur='Mid';  break;
            case 4: cur='Late';  break;
            case 5: cur='Fall';  break;
            case 6: cur='Wspring';  break;
            case 7: cur='Wmid';  break;
            case 8: cur='Wlate';  break;
            case 9: cur='Wfall';  break;
            case 10: cur='Smid';  break;
            case 11: cur='Slate';  break;
            case 12: cur='Sfall';  break;
            case 13: cur='Mlate';  break;
            case 14: cur='Mfall';  break;
            case 15: cur='Lfall';  break;
            default: cur='err';
        }
        console.log(cur);
        let dobj= this.state.editObj;
        dobj.cat=cur;
        this.setState({editObj:dobj});
    }
   
    AddMessage = () =>{
        let catg =this.state.editObj.cat;
        let txt = this.state.editObj.txt;
        let hed = this.state.editObj.head;
        addMessage({category:catg,text:txt,title:hed}).then((resp)=>{
                if(resp.data.err){
                    console.log("error in adding message");
                    console.log(resp.data.err);
                }
                else{
                    //add message to array in state
                    console.log("message",resp.data);   
                    this.appendMessage(resp.data.message);
                }
        }).catch((err) => {
            console.log("Catch an eror in adding messages",err)
          });
    }

    appendMessage =(m) =>{
        let prevlist= [...this.state.messages];
        prevlist.push(m);
        this.setState({messages:prevlist});
        this.setState({modalActive:false});
    }
    handleDelete =(obj) =>{
        console.log("Deleting message with id",obj._id);
        deleteMessage(obj._id).then((resp) =>{
            if(resp.data.err){
                console.log("error in deleting message");
                console.log(resp.data.err);
            }
            else{
                //add message to array in state
                console.log("message",resp.data);   
                this.componentDidMount();
            }

        })
        .catch((err) => {
            console.log("Catch an eror in deeleteing messages",err)
          });
    
    
    }
    handleEdit = (obj) =>{
        console.log("object to be edited is ",obj);
        editMessage(obj._id,obj).then((resp) =>{
            if(resp.data.err){
                console.log("error in updating message");
                console.log(resp.data.err);
            }
            else{
                //add message to array in state
                console.log("message",resp.data);   
                this.componentDidMount();
            }
        })
        .catch((err) => {
            console.log("Catch an eror in updating messages",err)
          });
    }
    render(){
        return(

            <div style={{padding:20}}>
              
                <Table
                objecttype="message"
                answers={this.state.messages}
                attributes={["Category", "Message"]}
                onDelete={this.handleDelete}
                onUpdate={this.handleEdit}
              />
     
      
              <Button bsStyle="primary" bsSize="large"
              onClick={() => this.setState({ modalActive: true })}> Add New</Button>

                <Modal show={this.state.modalActive}
                onHide={() => this.setState({ modalActive: false })}>
                    <Modal.Header closeButton>
                        <Modal.Title>Add Message</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form>
                        <FormGroup controlId="formBasicText">
                            <Row>
                            <Col md={12}>
                                
                            <ControlLabel>Category</ControlLabel>
                            <DropdownButton
                            onSelect={this.handleSelect}
                            title={this.state.editObj.cat}
                            id={`dropdown-basic`}
                            style={{margin:10}}
                            key={0}>
                            <MenuItem eventKey="1">Winter</MenuItem>
                            <MenuItem eventKey="2">Spring</MenuItem>
                            <MenuItem eventKey="3"> Summer</MenuItem>
                            <MenuItem eventKey="4">Transition</MenuItem>
                            <MenuItem eventKey="5">Autumn</MenuItem>
                            <MenuItem eventKey="6">Winter Spring</MenuItem>
                            <MenuItem eventKey="7">Winter Summer</MenuItem>
                            <MenuItem eventKey="8">Winter Transition</MenuItem>
                            <MenuItem eventKey="9">Winter Autumn</MenuItem>
                            <MenuItem eventKey="10">Spring Summer</MenuItem>
                            <MenuItem eventKey="11">Spring Transition</MenuItem>
                            <MenuItem eventKey="12">Spring Autumn</MenuItem>
                            <MenuItem eventKey="13">Summer Transition</MenuItem>
                            <MenuItem eventKey="14">Summer Autumn</MenuItem>
                            <MenuItem eventKey="15">Transition Autumn</MenuItem>
                            </DropdownButton>
                              
                            </Col>
                            </Row>

                            <Row>
                            <Col md={12}>
                                <ControlLabel>Text</ControlLabel>
                                <FormControl
                                    type="textarea"
                                    componentClass="textarea"
                                    style={{minHeight:100}}
                                    value={this.state.editObj.txt}
                                    placeholder="Enter the message text"
                                    onChange={e => this.handleEditChange(e, "txt")}
                                />
                            </Col>
                            </Row>
                            <Row>
                            <Col md={12}>
                                <ControlLabel>Title</ControlLabel>
                                <FormControl
                                    type="textarea"
                                    componentClass="textarea"
                                    style={{minHeight:50}}
                                    value={this.state.editObj.head}
                                    placeholder="Enter the header text"
                                    onChange={e => this.handleEditChange(e, "head")}
                                />
                            </Col>
                            </Row>
                        </FormGroup>
                        </form>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button bsStyle="primary" onClick={this.AddMessage}>
                            {" "}
                            Create
                        </Button>
                    </Modal.Footer>

                </Modal>

            </div>

        );
    }



}
export default Message;


// WEBPACK FOOTER //
// ./src/views/Quiz/Message.jsx